'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = readonly;

var _privateUtils = require('./private/utils');

function handleDescriptor(target, key, descriptor) {
  descriptor.writable = false;
  return descriptor;
}

function readonly() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0, _privateUtils.decorate)(handleDescriptor, args);
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/core-decorators/lib/readonly.js
// module id = 555
// module chunks = 0 1 2